type Props = {
  className?: string
  width?: number
  height?: number
}

export const BurgerIcon = ({ className, width = 43, height = 43 }: Props) => {
  return (
    <span className={className}>
      <svg width={width} height={height} viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_7208_1270"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="43"
          height="43"
        >
          <rect x="0.666504" y="0.499756" width="41.6667" height="41.6667" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7208_1270)">
          <mask
            id="mask1_7208_1270"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="3"
            width="42"
            height="9"
          >
            <rect x="0.666504" y="3.83325" width="40.7823" height="7.2809" rx="3.33333" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask1_7208_1270)">
            <rect x="-0.166504" y="-4.90381" width="41.6667" height="24.1667" fill="#D9D9D9" />
            <g filter="url(#filter0_f_7208_1270)">
              <g clipPath="url(#paint0_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(4.16356e-10 -0.0375 0.0375 4.16356e-10 21.5002 8.01278)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="21.5002" cy="10.0961" r="31.6667" />
            </g>
            <g filter="url(#filter1_f_7208_1270)">
              <g clipPath="url(#paint1_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(2.62962e-10 -0.0236842 0.0236842 2.62962e-10 34 6.2804)">
                  <foreignObject x="-935.185" y="-935.185" width="1870.37" height="1870.37">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(144, 217, 192, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="34" cy="7.59619" r="20" />
            </g>
            <g filter="url(#filter2_f_7208_1270)">
              <circle cx="20.6667" cy="7.16642" r="31.6667" fill="url(#paint2_radial_7208_1270)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask2_7208_1270"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="17"
            width="42"
            height="9"
          >
            <rect
              width="40.7823"
              height="7.2809"
              rx="3.33333"
              transform="matrix(-1 0 0 1 41.4492 17.781)"
              fill="#4B99E6"
            />
          </mask>
          <g mask="url(#mask2_7208_1270)">
            <rect width="41.6667" height="24.1667" transform="matrix(-1 0 0 1 42.2822 9.04395)" fill="#D9D9D9" />
            <g filter="url(#filter3_f_7208_1270)">
              <g clipPath="url(#paint3_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-4.16356e-10 -0.0375 -0.0375 4.16356e-10 20.6156 21.9605)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="31.6667" cy="31.6667" r="31.6667" transform="matrix(-1 0 0 1 52.2822 -7.6228)" />
            </g>
            <g filter="url(#filter4_f_7208_1270)">
              <g clipPath="url(#paint4_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-2.62962e-10 -0.0236842 -0.0236842 2.62962e-10 8.11572 20.2282)">
                  <foreignObject x="-935.185" y="-935.185" width="1870.37" height="1870.37">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(144, 217, 192, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 28.1157 1.54395)" />
            </g>
            <g filter="url(#filter5_f_7208_1270)">
              <circle cx="20.6667" cy="21.3334" r="31.6667" fill="url(#paint5_radial_7208_1270)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask3_7208_1270"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="31"
            width="42"
            height="9"
          >
            <rect x="0.666504" y="31.7283" width="40.7823" height="7.2809" rx="3.33333" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask3_7208_1270)">
            <rect x="-0.166504" y="22.9912" width="41.6667" height="24.1667" fill="#D9D9D9" />
            <g filter="url(#filter6_f_7208_1270)">
              <g clipPath="url(#paint6_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(4.16356e-10 -0.0375 0.0375 4.16356e-10 21.5002 35.908)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="21.5002" cy="37.9914" r="31.6667" />
            </g>
            <g filter="url(#filter7_f_7208_1270)">
              <g clipPath="url(#paint7_angular_7208_1270_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(2.62962e-10 -0.0236842 0.0236842 2.62962e-10 34 34.1754)">
                  <foreignObject x="-935.185" y="-935.185" width="1870.37" height="1870.37">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(144, 217, 192, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="34" cy="35.4912" r="20" />
            </g>
            <g filter="url(#filter8_f_7208_1270)">
              <circle cx="20.6667" cy="35.4999" r="31.6667" fill="url(#paint8_radial_7208_1270)" fillOpacity="0.4" />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_7208_1270"
            x="-15.4998"
            y="-26.9039"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint0_angular_7208_1270_clip_path">
            <circle cx="21.5002" cy="10.0961" r="31.6667" />
          </clipPath>
          <filter
            id="filter1_f_7208_1270"
            x="8.66667"
            y="-17.7371"
            width="50.6667"
            height="50.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint1_angular_7208_1270_clip_path">
            <circle cx="34" cy="7.59619" r="20" />
          </clipPath>
          <filter
            id="filter2_f_7208_1270"
            x="-16.3333"
            y="-29.8336"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <filter
            id="filter3_f_7208_1270"
            x="-16.3846"
            y="-12.9561"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint3_angular_7208_1270_clip_path">
            <circle cx="31.6667" cy="31.6667" r="31.6667" transform="matrix(-1 0 0 1 52.2822 -7.6228)" />
          </clipPath>
          <filter
            id="filter4_f_7208_1270"
            x="-17.2176"
            y="-3.78939"
            width="50.6667"
            height="50.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint4_angular_7208_1270_clip_path">
            <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 28.1157 1.54395)" />
          </clipPath>
          <filter
            id="filter5_f_7208_1270"
            x="-16.3333"
            y="-15.6666"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <filter
            id="filter6_f_7208_1270"
            x="-15.4998"
            y="0.991374"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint6_angular_7208_1270_clip_path">
            <circle cx="21.5002" cy="37.9914" r="31.6667" />
          </clipPath>
          <filter
            id="filter7_f_7208_1270"
            x="8.66667"
            y="10.1579"
            width="50.6667"
            height="50.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <clipPath id="paint7_angular_7208_1270_clip_path">
            <circle cx="34" cy="35.4912" r="20" />
          </clipPath>
          <filter
            id="filter8_f_7208_1270"
            x="-16.3333"
            y="-1.50008"
            width="74.0002"
            height="73.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1270" />
          </filter>
          <radialGradient
            id="paint2_radial_7208_1270"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(47.3333 38.8331) rotate(-110.519) scale(76.0768)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
          <radialGradient
            id="paint5_radial_7208_1270"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(47.3333 53.0001) rotate(-110.519) scale(76.0768)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
          <radialGradient
            id="paint8_radial_7208_1270"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(47.3333 67.1666) rotate(-110.519) scale(76.0768)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
        </defs>
      </svg>
    </span>
  )
}
